import { combineReducers } from "redux";

import { reducer as authReducer, UserState } from "../../pages/Auth/reducer";
import { LOGOUT } from "../../pages/Auth/actions";
import { reducer as categoryReducer, CategoryState } from "../../pages/Categories/reducer";
import { reducer as userPortfolioReducer, UserPortfolioState } from "../../pages/UserProfile/components/UserPortfolio/reducer";
import { reducer as handymanReducer, HandymanState } from "../../pages/BrowseHandyman/reducer";
import { reducer as orderReducer, OrderState } from "../../pages/Orders/reducer";
import { reducer as chatReducer, ChatState } from "../../pages/Chats/reducer";
import reviewReducer, { ReviewState } from "./reducers/reviewReducer";

export type Dictionary = {
    Id: number;
    Name: string;
};

export interface HandymanAppState {
    user: UserState;
    category: CategoryState;
    userPortfolio: UserPortfolioState;
    handyman: HandymanState;
    order: OrderState;  
    chat: ChatState;
    review: ReviewState;
}

const appReducer = combineReducers<HandymanAppState>({
    user: authReducer as any,
    category: categoryReducer as any,
    userPortfolio: userPortfolioReducer as any,
    handyman: handymanReducer as any,
    order: orderReducer as any,
    chat: chatReducer as any,
    review: reviewReducer as any
}) as any;

const rootReducer = (state: any, action: any) => {
    // Reset the entire state to undefined on logout
    if (action.type === LOGOUT) {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;